<div *ngIf="offer$ | async as offer">
  <!-- Mobile: full-bleed hero with back button overlaid -->
  <div class="mobile-hero-wrapper d-md-none">
    <img [src]="offer.OfferImage | contentImage : '6'" alt="" class="mobile-hero-img" />
    <button class="back-btn back-btn-overlay" (click)="goBack()">
      <span class="material-icons ms-0">arrow_back_ios_new</span>
    </button>
  </div>

  <div class="container py-md-4">
    <!-- Desktop: back button in normal flow -->
    <button class="back-btn mb-4 d-none d-md-flex" (click)="goBack()">
      <span class="material-icons ms-0">arrow_back_ios_new</span>
    </button>

    <div class="row g-md-4">
      <!-- Desktop only: left col with hero image and accordion -->
      <div class="col-md-7 d-none d-md-block">
        <div class="offer-hero">
          <img [src]="offer.OfferImage | contentImage : '6'" alt="" class="offer-hero-img" />
        </div>
        <ng-container *ngTemplateOutlet="accordionTpl"></ng-container>
      </div>

      <!-- Info card: full width on mobile, col-5 on desktop -->
      <div class="col-12 col-md-5 mb-2 mb-lg-0">
        <div class="offer-detail-card">
          <div class="d-flex flex-column gap-3">
            <div class="detail-logo-wrapper">
              <img [src]="offer.CompanyImage | contentImage : '6'" alt="{{ offer.CompanyName }}" class="detail-logo" />
            </div>
            <div>
              <p class="detail-company-name mb-1">{{ offer.CompanyName }}</p>
              <h3 class="detail-offer-title mb-0">{{ offer.OfferName }}</h3>
            </div>
          </div>
          <ng-container *ngIf="offer.Locked; else unlockedActions">
            <button class="btn-locked w-100" disabled>
              <span class="material-icons">lock</span>
              Locked
            </button>
          </ng-container>
          <ng-template #unlockedActions>
            <ng-container
              *ngIf="
                offer.OfferType === OfferType.SingleCodeOffer || offer.OfferType === OfferType.UniqueCodeOffer;
                else goToOfferBtn
              "
            >
              <button *ngIf="!revealedCode && !revealCodeError" class="btn-reveal-code w-100" (click)="revealCode(offer.OfferId)">
                {{ 'brand.codes.reveal' | translate }}
              </button>
              <p *ngIf="revealCodeError" class="text-danger font-size-14 fw-bold mb-0 text-center">
                {{ revealCodeError | translate }}
              </p>
              <div *ngIf="revealedCode" class="reveal-code-box w-100" [class.border-club1901-primary]="isClub1901">
                <span
                  class="reveal-code-text"
                  [class.text-primary]="!isClub1901"
                  [class.text-club1901-primary]="isClub1901"
                  >{{ revealedCode }}</span
                >
                <button class="copy-btn" (click)="copyCode()" [title]="'Copy code'">
                  <span class="material-symbols-outlined">{{ codeCopied ? 'check' : 'content_copy' }}</span>
                </button>
              </div>
            </ng-container>
            <ng-template #goToOfferBtn>
              <button
                *ngIf="offer.OfferType !== OfferType.NoAction"
                [class.club1901]="isClub1901"
                class="btn-go-to-offer w-100"
                (click)="claimOffer(offer.OfferId)"
              >
                {{ 'brands.go.to.offer' | translate }}
              </button>
            </ng-template>
          </ng-template>
        </div>
      </div>

      <!-- Mobile only: accordion below card -->
      <div class="col-12 d-md-none">
        <ng-container *ngTemplateOutlet="accordionTpl"></ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #accordionTpl>
  <div class="accordion-section" *ngIf="offer$ | async as offer">
    <div class="accordion-item" [class.border-0]="!offer.TermsAndConditions">
      <button class="accordion-header" (click)="descriptionOpen = !descriptionOpen">
        <span
          [class.text-primary]="descriptionOpen && !isClub1901"
          [class.text-club1901-primary]="descriptionOpen && isClub1901"
          [class.fw-bold]="descriptionOpen"
          >Description</span
        >
        <span class="material-icons">{{ descriptionOpen ? 'expand_less' : 'expand_more' }}</span>
      </button>
      <div class="accordion-body" *ngIf="descriptionOpen" [@slideDown]>
        <p class="mb-0">{{ offer.OfferDescription }}</p>
      </div>
    </div>
    <div class="accordion-item border-0" *ngIf="offer.TermsAndConditions">
      <button class="accordion-header" (click)="tcsOpen = !tcsOpen">
        <span
          [class.text-primary]="tcsOpen && !isClub1901"
          [class.text-club1901-primary]="tcsOpen && isClub1901"
          [class.fw-bold]="tcsOpen"
          >T&amp;Cs</span
        >
        <span class="material-icons">{{ tcsOpen ? 'expand_less' : 'expand_more' }}</span>
      </button>
      <div class="accordion-body" *ngIf="tcsOpen" [@slideDown]>
        <p class="mb-0">{{ offer.TermsAndConditions }}</p>
      </div>
    </div>
  </div>
</ng-template>
